import React from 'react';
import ProjectMain from '../components/Project/ProjectMain';

const Project = () => {
  return <ProjectMain />;
};

export default Project;
